var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_06_adaptacje",
    "data-name": "06_adaptacje",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(29.216 29.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M335.87,184.035c5.131-.516,11.209.956,17.442,4.545a60.158,60.158,0,0,1,14.318,11.837A83.886,83.886,0,0,1,381.646,222c5.807,12.823,11.153,34.608.233,46.2l.052.06",
    transform: "translate(-304.529 -179.987)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4559",
    "data-name": "Path 4559",
    d: "M317.771,184.49c-3.254,2.625-4.511,5.82-3.779,8.885.62,2.575,2.634,5.07,6.069,7.042,4.055,2.109,10.021,3.15,15.152,3.15s11.1-1.042,15.152-3.15c3.435-1.971,5.449-4.468,6.069-7.042.732-3.065-.525-6.258-3.779-8.885",
    transform: "translate(-286.429 -180.442)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4560",
    "data-name": "Path 4560",
    d: "M163.07,435.88c.249,6.922,4.873,13.8,13.912,19.112,9.626,5.33,22.195,8.247,34.686,8.247s25.062-2.919,34.686-8.247c9.04-5.312,13.663-12.19,13.912-19.112",
    transform: "translate(-162.884 -386.507)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    d: "M245.381,268.2l.052-.059c-10.921-11.588-5.575-33.373.233-46.2a83.88,83.88,0,0,1,14.015-21.584A61.263,61.263,0,0,1,274,188.28c6.233-3.59,12.311-4.821,17.442-4.3",
    transform: "translate(-225.215 -179.929)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 97.567,
    transform: "translate(48.783)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45333",
    "data-name": "Ellipse 45333",
    cx: 48.783,
    cy: 48.783,
    r: 48.783,
    fill: "none",
    stroke: "#dbb258",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M162.07,249.382c0-7,2.849-14.307,7.024-20.1a50.658,50.658,0,0,1,20.532-16.34,51.458,51.458,0,0,1,42.442,0A50.658,50.658,0,0,1,252.6,229.28c4.176,5.8,7.024,13.1,7.024,20.1",
    transform: "translate(-162.065 -200.009)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    d: "M195.01,303a15.005,15.005,0,0,0,1.085,3.857c2.423,5.739,7.971,10.017,13.421,12.742,8.085,4.107,18.208,6.155,28.332,6.155s20.249-2.048,28.332-6.155c5.45-2.724,11-7,13.421-12.742A15.007,15.007,0,0,0,280.688,303",
    transform: "translate(-189.066 -277.585)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 156,
    height: 156,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.cd795590e3a6eb95d26841225174a14b.svg";
export { ForwardRef as ReactComponent };